const CMOS = {
  '1/3″': {
    sensorWidth: 4.80,
    sensorHeight: 3.60,
    diagonalSize: 6.00,
    ratio: '4:3'
  },
  '1/2.7″': {
    sensorWidth: 5.37,
    sensorHeight: 4.04,
    diagonalSize: 6.72,
    ratio: '4:3'
  },
  '1/2.5″': {
    sensorWidth: 5.76,
    sensorHeight: 4.29,
    diagonalSize: 7.18,
    ratio: '4:3'
  },
  '1/2.3″': {
    sensorWidth: 6.16,
    sensorHeight: 4.62,
    diagonalSize: 7.70,
    ratio: '4:3'
  },
  '1/2″': {
    sensorWidth: 6.40,
    sensorHeight: 4.80,
    diagonalSize: 8.00,
    ratio: '4:3'
  },
  '1/1.7″': {
    sensorWidth: 7.60,
    sensorHeight: 5.70,
    diagonalSize: 9.50,
    ratio: '4:3'
  },
  '1/1.3″': {
    sensorWidth: 9.6,
    sensorHeight: 7.2,
    diagonalSize: 12.0,
    ratio: '4:3'
  },
  '1″': {
    sensorWidth: 13.20,
    sensorHeight: 8.80,
    diagonalSize: 15.86,
    ratio: '3:2'
  },
  'APS-C': {
    sensorWidth: 23.50,
    sensorHeight: 15.60,
    diagonalSize: 28.20,
    ratio: '3:2'
  },
  'Full Frame': {
    sensorWidth: 36.00,
    sensorHeight: 24.00,
    diagonalSize: 43.30,
    ratio: '3:2'
  }
};

export const Cameras = {
 
  M30:{
   name: "M30",
    type: 52,
    wide: {
      // 广角相机参数
      sensorFormat: '1/2"',
      sensorWidth: 6.4, // mm
      sensorHeight: 4.8, // mm
      focalLength: 4.5, // mm
      imageWidth: 4000,
      imageHeight: 3000
    },
  },
  M30T: {
    name: "M30T",
    type: 53,
    wide: {
      // 广角相机参数
      sensorFormat: '1/2"',
      sensorWidth: 6.4, // mm
      sensorHeight: 4.8, // mm
      focalLength: 4.5, // mm
      imageWidth: 4000,
      imageHeight: 3000
    },
    infrared: {
      // 红外相机参数
      sensorFormat: '1/2"',
      pixelSize: 12, // 像元间距单位：μm（微米）
      sensorWidth: 7.68, // mm  // 640 × 12μm = 7.68 mm
      sensorHeight: 6.144, // mm  // 512 × 12μm = 6.144 mm
      focalLength: 9.1, // mm
      imageWidth: 640,
      imageHeight: 512
    }
  },

  M3D: {
    name: 'M3D',
    type: 80,
    wide: {
      // 广角相机参数
      sensorFormat: '4/3"', // 传感器尺寸标称
      sensorWidth: 17.02, // mm
      sensorHeight: 13.0, // mm
      focalLength: 12, // mm（推导自等效焦距 24mm）
      imageWidth: 5280, // 像素宽度（符合 4:3 比例）
      imageHeight: 3956 // 像素高度
    }
  },
  M3TD: {
    name: 'M3TD',
    type: 81,
    wide: {
      sensorFormat: '1/1.32"',
      sensorWidth: 9.44, 
      sensorHeight: 7.08,
      focalLength: 6.655 ,
      imageWidth: 4032,
      imageHeight: 3024,        // px
    },
    infrared: {
        pixelSize: 12, // 像元间距单位：μm（微米）
        sensorWidth: 7.68,    // mm
        sensorHeight: 6.144,  // mm
        focalLength: 9.1,    // mm，基于等效焦距换算
        imageWidth: 640,
        imageHeight: 512
    }
  },
    H20T: {
    name: 'H20T',
    /**
     * type的枚举值请参考大疆产品支持页面https://developer.dji.com/doc/cloud-api-tutorial/cn/overview/product-support.html
     * 中的相机枚举值中type-subtype-gimbalindex中的type字段
     */
    type: 43,
    wide: {
      // 广角相机参数
      sensorFormat: '1/2.3"',
      sensorWidth: 6.16, // mm
      sensorHeight: 4.62, // mm
      focalLength: 4.5, // mm
      imageWidth: 4056,
      imageHeight: 3040
    },
    infrared: {
      // 红外相机参数（H20T）
      sensorFormat: '1/2.3"', // 近似估算值
      pixelSize: 12, // μm（像元间距
      sensorWidth: 7.68, // mm = 640 × 0.012mm
      sensorHeight: 6.144, // mm = 512 × 0.012mm
      focalLength: 12, // mm
      imageWidth: 640, // px
      imageHeight: 512 // px
    }
  },
  H30T: {
    name: "H30T",
    /**
     * type的枚举值请参考大疆产品支持页面https://developer.dji.com/doc/cloud-api-tutorial/cn/overview/product-support.html
     * 中的相机枚举值中type-subtype-gimbalindex中的type字段
     */
    type: 83,
    wide: {
      // 广角相机参数
      sensorFormat: '1/1.3″',
      sensorWidth: 9.66, // mm
      sensorHeight: 7.24, // mm
      focalLength: 6.72, // mm
      imageWidth: 4032,
      imageHeight: 3024
    },
    infrared: {
     
      sensorFormat: '1/1"',              // 行业标准近似格式
      pixelSize: 12,                     // 像元间距单位：μm（微米）
      sensorWidth: 15.36,                // mm（1280 × 12μm）
      sensorHeight: 12.288,              // mm（1024 × 12μm）
      focalLength: 24,                   // mm（实际等效焦距）
      imageWidth: 1280,                  // px
      imageHeight: 1024                  // px
    }
  },
  Matrice4TD:{
    name:"Matrice 4TD",
    type:99,
     wide: {
      // 广角相机参数
      sensorFormat: '1/1.3″',
      sensorWidth:9.67 , // mm
      sensorHeight: 7.2, // mm
      focalLength: 6.74, // mm
      imageWidth: 4032,
      imageHeight: 3024
    },
  }
};


/**
 * 飞行器主类型枚举值请参考产品支持页面中的飞行器/遥控器/机场枚举值中的主类型(type)
 * https://developer.dji.com/doc/cloud-api-tutorial/cn/overview/product-support.html
 */
const Devices= [
  {
    name: 'Matrice 30',
    type: 67,
    children:[
      {
        name: 'Matrice 30',
        domain:'0',
        type: 67,
        sub_type: "0",
        payload:{
          cameras: [Cameras.M30]
        }
      },
      {
        name: 'Matrice 30T',
        domain:'0',
        type: 67,
        sub_type: "1",
        payload:{
          cameras: [Cameras.M30T]
        }
      },
    ]
  
  },
  {
    name: 'Matrice 3D',
    type: 91,
    children:[
      {
        name: 'Matrice 3D',
        domain:'0',
        type: 91,
        sub_type: "0",
      },
      {
        name: 'Matrice 3TD',
        domain:'0',
        type: 91,
        sub_type: "1",
        payload:{
          cameras: [Cameras.H20T, Cameras.M3TD]
        }
      },
    ]
  },
  {
    name:"Matrice 4D",
    type: 100,
    children:[
      {
        name: 'Matrice 4D',
        domain:'0',
        type: 100,
        sub_type: "0",
      },
      {
        name: 'Matrice 4TD',
        domain:'0',
        type: 100,
        sub_type: "1",
        payload:{
          cameras: [Cameras.Matrice4TD]
        }
      },
    ]
  },
  {
    name: 'Matrice 300 RTK',
    type: 60,
    children:[
      {
        name: 'Matrice 300 RTK',
        domain:'0',
        type: 60,
        sub_type: "0",
        payload:{
          cameras: [ Cameras.H20T,Cameras.H30T]
        }
      },
    ]
  },
  {
    name:"Q20Y",
    type: "Q20Y",
    

  }
]
export const DeviceOptions = Devices

export const CameraOptions = Object.values(Cameras);